import type { InventoryStockLevelKey } from './stock-level-key.js';
import type { StockLevelWarehouse } from './types.js';

export function inventoryWarehouseStockLevel(
  warehouse: StockLevelWarehouse,
): Exclude<InventoryStockLevelKey, 'NEVER_STOCKED' | 'OUT_OF_STOCK'> {
  if (warehouse.belowReorder) return 'BELOW_REORDER';
  if (warehouse.overstocked) return 'OVERSTOCKED';
  if (warehouse.reorderPoint == null && warehouse.orderUpToLevel == null) return 'NO_LEVELS';
  return 'IN_RANGE';
}
